var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230 107",
    style: {
      enableBackground: "new 0 0 230 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#41118E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    transform: "translate(-190 -100.113)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.1,162.1h-7v-2.7c-2.1,2.4-5.2,3.6-9.2,3.6c-4.1,0-7.4-1.6-9.8-4.7c-2.4-3.2-3.7-6.9-3.7-11.1 c0-4.2,1.2-7.9,3.7-10.8c2.5-3,5.7-4.5,9.6-4.5c4.1,0,7.3,1.2,9.4,3.7v-2.7h7V162.1z M258.9,147.5c0-2.7-0.8-4.9-2.3-6.7 c-1.5-1.8-3.5-2.6-5.9-2.6c-2.4,0-4.3,0.9-5.8,2.6c-1.5,1.7-2.3,4-2.3,6.8c0,2.8,0.8,5.1,2.3,6.8c1.5,1.7,3.5,2.6,5.9,2.6 c2.4,0,4.4-0.8,5.8-2.5C258.2,152.7,258.9,150.4,258.9,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284,135.5c1.8-2.4,4.6-3.6,8.4-3.6c3.3,0,5.9,1.5,7.8,4.6c1.9-3.1,4.9-4.6,9.1-4.6c6.2,0,9.2,4,9.2,12v18.2 h-7.1v-15.4c0-6.2-1.7-9.3-5.1-9.3c-3.4,0-5.1,3.5-5.1,10.4v14.4h-7.2v-14.8c0-6.6-1.5-9.9-4.5-9.9c-3.7,0-5.6,3.5-5.6,10.4v14.4 h-7.2v-29.2h7.2V135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.1,120.6c0,1.1-0.4,2.1-1.3,3s-1.8,1.3-3,1.3c-1.1,0-2.1-0.4-3-1.3s-1.3-1.8-1.3-3s0.4-2.1,1.3-3 s1.8-1.3,3-1.3c1.1,0,2.1,0.4,3,1.3S339.1,119.5,339.1,120.6z M338.6,162.1h-7.2v-29.2h7.2V162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.9,162.1h-7.2v-22.8h-3.5v-5.8h3.5V123h7.2v10.5h5.7v5.8h-5.7V162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.8,132.9h8.3l7.6,17.5l8-17.5h8.1l-20.7,41.4h-8l9-16.7L369.8,132.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.6,174.6v17.5h-1.8V184h-10.9v8.1h-1.8v-17.5h1.8v7.8h10.9v-7.8H223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241,186.1h-11c0.2,2.7,2.3,4.6,5.2,4.6c1.6,0,3-0.6,4-1.7l1,1.1c-1.2,1.4-3,2.1-5.1,2.1 c-4.1,0-6.9-2.8-6.9-6.7c0-3.9,2.7-6.7,6.4-6.7s6.4,2.7,6.4,6.7C241,185.7,241,185.9,241,186.1z M230,184.8h9.3 c-0.2-2.6-2.1-4.4-4.7-4.4C232.1,180.4,230.2,182.2,230,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,178.9v1.7c-0.1,0-0.3,0-0.4,0c-2.7,0-4.4,1.7-4.4,4.8v6.7h-1.8V179h1.7v2.6 C247.8,179.8,249.4,178.9,251.9,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267,186.1h-11c0.2,2.7,2.3,4.6,5.2,4.6c1.6,0,3-0.6,4-1.7l1,1.1c-1.2,1.4-3,2.1-5.1,2.1 c-4.1,0-6.9-2.8-6.9-6.7c0-3.9,2.7-6.7,6.4-6.7c3.7,0,6.4,2.7,6.4,6.7C267,185.7,267,185.9,267,186.1z M256,184.8h9.3 c-0.2-2.6-2.1-4.4-4.7-4.4C258.1,180.4,256.2,182.2,256,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.5,177.4v1.5h4v1.5h-4v11.6h-1.8v-11.6h-2.3V179h2.3v-1.6c0-2.3,1.4-3.9,4-3.9c1,0,2,0.3,2.6,0.8 l-0.6,1.3c-0.5-0.4-1.2-0.7-1.9-0.7C281.3,174.9,280.5,175.8,280.5,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286,185.5c0-3.9,2.8-6.7,6.7-6.7c3.8,0,6.7,2.8,6.7,6.7c0,3.9-2.8,6.7-6.7,6.7 C288.9,192.2,286,189.4,286,185.5z M297.6,185.5c0-3.1-2.1-5.1-4.9-5.1c-2.8,0-4.9,2-4.9,5.1s2.1,5.1,4.9,5.1 C295.5,190.7,297.6,188.6,297.6,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.3,178.9v1.7c-0.1,0-0.3,0-0.4,0c-2.7,0-4.4,1.7-4.4,4.8v6.7h-1.8V179h1.7v2.6 C306.2,179.8,307.8,178.9,310.3,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.5,179l-6.6,14.7c-1.1,2.6-2.5,3.4-4.4,3.4c-1.2,0-2.4-0.4-3.2-1.2l0.8-1.3c0.6,0.7,1.4,1,2.4,1 c1.2,0,2-0.5,2.7-2.2l0.6-1.3L319,179h1.8l4.9,11.2l4.9-11.2H332.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.9,185.5c0-3.9,2.8-6.7,6.7-6.7c3.8,0,6.7,2.8,6.7,6.7c0,3.9-2.8,6.7-6.7,6.7 C336.8,192.2,333.9,189.4,333.9,185.5z M345.5,185.5c0-3.1-2.1-5.1-4.9-5.1c-2.8,0-4.9,2-4.9,5.1s2.1,5.1,4.9,5.1 C343.4,190.7,345.5,188.6,345.5,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.4,179v13.1h-1.7v-2.4c-0.9,1.6-2.6,2.5-4.7,2.5c-3.3,0-5.5-1.9-5.5-5.6V179h1.8v7.4 c0,2.8,1.4,4.2,3.9,4.2c2.7,0,4.5-1.8,4.5-4.8V179H363.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmityLogo);
export default __webpack_public_path__ + "static/media/amity__logo.4217843e01f619c165cdc8bce99481bc.svg";
export { ForwardRef as ReactComponent };